import { html, ref } from '@microsoft/fast-element';
export const foundationNotificationListenerTemplate = html `
  <template ${ref('notificationListener')}>
    <slot></slot>
  </template>
`;
